import NumberFormatCustom from 'components/NumberFormat/NumberFormatCustom';
import React, { ComponentProps } from 'react';

/**
 * Component displaying an amount with fixed currency
 * This component can be used with NumberFormatCustom for harmonization
 */
const AmountFormat = (props: ComponentProps<typeof NumberFormatCustom>) => {
    return <NumberFormatCustom displayType="text" suffix=" €" {...props} />;
};

export default AmountFormat;
